export const BUY = 'Pirkimas';
export const SALE = 'Pardavimas';
export const RENT = 'Nuoma';
export const OTHER = 'Bendrijos skelbimai';
export const ALL = 'Visi skelbimai';
